import { inject, Injectable, Injector, Provider } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AbstractSecurityStorage,
  LoginResponse,
  OidcSecurityService,
} from 'angular-auth-oidc-client';
import { OauthService } from '@tiltgroup/web-components';
import { EmbedAuthService } from './embed-auth.service';
import { EmbedSecurityStorage } from './embed-security-storage';

/**
 * The OIDC client on /embed/ pages: a refresh asks the framing page for a token, and
 * it never redirects to the login page, which can't run in a frame.
 */
@Injectable()
export class EmbedOidcSecurityService extends OidcSecurityService {
  // Read when called: EmbedAuthService itself depends on this service.
  private readonly _injector = inject(Injector);

  override forceRefreshSession(): Observable<LoginResponse> {
    return this._injector.get(EmbedAuthService).refreshToken();
  }

  override authorize(): void {
    this._injector.get(EmbedAuthService).signOut();
  }
}

/** Login and logout on /embed/ pages: the framing page signs the user in and out. */
@Injectable()
export class EmbedOauthService extends OauthService {
  private readonly _injector = inject(Injector);

  override checkAuth(): void {
    // The page signs in with the parent's tokens, never by redirect.
  }

  override reauthenticate(): void {
    this._injector.get(EmbedAuthService).signOut();
  }

  override logout(): void {
    this._injector.get(EmbedAuthService).signOut();
  }
}

/** For /embed/ pages, which the framing page signs in; see EmbedAuthService. */
export function provideEmbedAuth(): Provider[] {
  return [
    { provide: AbstractSecurityStorage, useExisting: EmbedSecurityStorage },
    { provide: OidcSecurityService, useClass: EmbedOidcSecurityService },
    { provide: OauthService, useClass: EmbedOauthService },
  ];
}
